import(/* webpackMode: "eager" */ "/workspace/LMS/src/app/page.tsx");
